import * as React from "react";
import { cn } from "@/lib/utils";

const variants = {
  neutral: "bg-bg-tertiary text-text-secondary border-border-default",
  pink: "bg-accent-pink/15 text-accent-pink border-accent-pink/40",
  "pink-tier": "bg-accent-pink text-[#091424] border-transparent",
  success: "bg-success/15 text-success border-success/40",
  warning: "bg-warning/15 text-warning border-warning/40",
  danger: "bg-danger/15 text-danger border-danger/40",
  bronze: "bg-bronze/15 text-bronze border-bronze/40",
  silver: "bg-silver/15 text-silver border-silver/40",
};

const JeaBadge = React.forwardRef(
  ({ className, variant = "neutral", uppercase = true, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full border text-[11px] font-semibold tracking-[0.06em]",
        uppercase && "uppercase",
        variants[variant] || variants.neutral,
        className
      )}
      {...props}
    />
  )
);
JeaBadge.displayName = "JeaBadge";

export { JeaBadge };
export default JeaBadge;
